import { el } from "@dhx/ts-common/dom";
import { PropertyEvents } from "../types";
import { validate } from "./../validate";
import { Text } from "./Text";

export class Inputs extends Text {
	private _map: any;

	constructor(config, ev) {
		super(config, ev);

		this._map = {};
		config.options = config.options.map(a => {
			this._map[a.id] = a;
			return { ...a };
		});
	}
	setValue(obj: any, silent?: boolean) {
		for (const key in obj) {
			const option = this._map[key];
			this._setValue(option, obj[key], true);
		}
		if (!silent) {
			this._evs.fire(PropertyEvents.change);
		}
	}
	getValue() {
		const obj = {};
		const opts = this._config.options;
		for (let i = 0; i < opts.length; i++) {
			const current = opts[i];
			obj[current.id] = current.value;
		}
		return obj;
	}
	clear() {
		const opts = this._config.options;
		const obj = {};
		for (let i = 0; i < opts.length; i++) {
			obj[opts[i].id] = "";
		}
		this.setValue(obj, true);
	}
	toVDOM() {
		const options = this._config.options;
		const len = options.length;
		const positionDesc = [];
		const positionEdit = [];

		for (let i = 0; i < len; i++) {
			const opt = options[i];
			positionEdit.push(
				el("input", {
					type: "text",
					name: opt.id,
					value: opt.value,
					index: i,
					class: opt.invalid ? "dhx_invalid" : "",
					_ref: this._uid + i,
					onchange: this._handlers.change,
					oninput: this._handlers.change,
				})
			);
			positionDesc.push(el("span", opt.label));
		}
		return el(".edit-section", [
			el(".inputs_group", [el("span", this._config.label), ...positionEdit]),
			el(".inputs_group_desc", positionDesc),
		]);
	}
	protected _changed(e: any) {
		const value = e.target.value;
		const index = e.target.getAttribute("index");
		const option = this._config.options[index];

		if (value !== option.value) {
			if (validate(value, option.validate)) {
				e.target.setAttribute("class", "");
				this._setValue(option, value);
			} else {
				e.target.setAttribute("class", "dhx_invalid");
			}
		}
	}
	private _setValue(option: any, value: string, silent?: boolean) {
		const old = option.value;
		option.value = value;
		// [todo]
		// option.invalid = !validate(option.value, option.validate);
		if (!silent) {
			this._evs.fire(PropertyEvents.change, [option.id, value, old]);
		}
	}
}
